import $ from 'jquery';
import fitvids from 'fitvids';

export default class Video {
  constructor(instance) {
    this.$el = $(instance.el);
    this.$overlayPlay = $('[data-overlay-play]', this.$el);
    this.$overlayPlay.on('click.video', event => this.activateVideo(event));

    fitvids(this.$el);
  }

  activateVideo(event) {
    const $target = $(event.currentTarget);
    const $videoWrapper = $target.parents('[data-video-wrapper]');
    const $overlay = $videoWrapper.find('[data-video-overlay]');
    const $video = $videoWrapper.find('iframe');

    if (!$video.length) { return; }

    $videoWrapper.addClass('active');

    setTimeout(() => $overlay.addClass('inactive'),
      200);

    setTimeout(() => {
      const $videoSrc = $video.attr('src');
      const delimiter = ($videoSrc != null ? $videoSrc.indexOf('?') : undefined) === -1 ? '?' : '&';
      const $videoSrcNew = `${$videoSrc + delimiter}autoplay=1`;
      $video.attr('src', $videoSrcNew);

      $overlay.remove();
    },
    400);
  }

  unload() {
    this.$overlayPlay.off('.video');
  }
}
